import { render, staticRenderFns } from "./add-and-edit.vue?vue&type=template&id=3e22238e&"
import script from "./add-and-edit.vue?vue&type=script&lang=js&"
export * from "./add-and-edit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports